export function brandAccordion() {
    const accordion = $(".brand-accordion");
    const accordionItem = accordion.find(".accordion-item");
    const accordionItemTitle = accordionItem.find(".accordion-title");

    accordionItemTitle.on("click", function () {
        let parent = $(this).closest(".accordion-item");
        parent.toggleClass("active");
        parent.find(".accordion-content").slideToggle();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/brand-accordion.js